module.exports = __webpack_public_path__ + "static/media/badge8.425e4c26.svg";